import { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '@appsumo/dorado-react';

import { faTag } from '@fortawesome/free-solid-svg-icons';

import clsx from 'clsx';

export function SumoDayIncentive({
  className,
  version = 'checkout',
}: {
  className?: string;
  version?: 'cart' | 'checkout';
}): ReactElement {
  const content = (
    <>
      <Link href="/accounts/login?next=/checkout" className="text-bolt">
        Log in or sign up
      </Link>{' '}
      to claim 10% off{version === 'checkout' && ' for Sumo Day'}!
    </>
  );

  const faIconClasses = clsx(
    'mr-4 text-dollar',
    { 'text-2xl': version === 'checkout' },
    { 'self-center': version === 'cart' },
  );
  const contentClasses = clsx(
    version === 'cart' ? 'text-sm font-bold' : 'font-medium',
  );

  return (
    <>
      <div
        className={clsx(
          `flex bg-dollar/10 p-4 ${clsx(className, {
            'py-2': version === 'cart',
          })}`,
        )}
      >
        <FontAwesomeIcon icon={faTag} className={faIconClasses} />
        <div className={contentClasses}>{content}</div>
      </div>
    </>
  );
}
